<template>
	<div class="md-layout">
		<div class="md-layout-item md-medium-size-50 md-size-50">
			<h4>ការគ្រប់គ្រងផ្ទាំងស្លាយ</h4>
		</div>
		<div class="md-layout-item md-medium-size-100 md-size-100">
			<md-card>
				<md-card-content>
					<loading v-if="!loaded" />
					<div v-if="loaded">
						<md-table v-if="filmList.length > 0">
							<md-table-row>
								<md-table-head></md-table-head>
								<md-table-head>រូបភាពផ្ទាំងស្លាយ</md-table-head>
								<md-table-head>ភាពយន្ត</md-table-head>
								<md-table-head>ថ្ងៃបង្កើត</md-table-head>
								<md-table-head>ស្ថានភាព</md-table-head>
								<md-table-head>សកម្មភាព</md-table-head>
							</md-table-row>

							<md-table-row v-for="(film, index) in filmList">
								<!-- <md-table-cell></md-table-cell> -->
								<md-table-cell>​{{ index + 1 }}</md-table-cell>
								<md-table-cell><img :src="config.cdn + 'images/' + film.image_cover_url" class="cover"></md-table-cell>
								<md-table-cell><img :src="config.cdn + 'images/' + film.poster_url" class="poster"><b>{{film.title}}</b></md-table-cell>
								<md-table-cell>{{config.datelify(film.created_date)[1]}}</md-table-cell>
								<md-table-cell><span class="green">{{config.getStatus("1")}}</span></md-table-cell>
								<md-table-cell>
									<md-button class="md-just-icon md-simple md-success" @click="onUpdate(film.hash)">
										<md-icon>publish</md-icon>
										<md-tooltip md-direction="top">យកទៅខាងលើ</md-tooltip>
									</md-button>
									<md-button class="md-just-icon md-simple md-primary" @click="onDelete(film.hash)">
										<md-icon>delete</md-icon>
										<md-tooltip md-direction="top">លុយចេញពីផ្ទាំងស្លាយ</md-tooltip>
									</md-button>
								</md-table-cell>
							</md-table-row>
						</md-table>
						<h5 class="text-center" v-if="filmList.length == 0 && loaded == true">មិនមានផ្ទាំងស្លាយ</h5>
						<div class="text-right" v-if="loadMore">
							<md-button class="md-primary" @click="searchHandler(true)">{{translate(locale.showMore)}}</md-button>
						</div>
					</div>

					<md-dialog-confirm :md-active.sync="disableDialogActive"
						:md-title="'តើអ្នកពិតជាចង់លុបមែនឬ​ ?'" :md-confirm-text="'យល់ព្រម'"
						:md-cancel-text="'បោះបង់'" @md-cancel="onCancel" @md-confirm="onDelete" />
				</md-card-content>
			</md-card>
		</div>
	</div>
</template>

<script>

	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.searchHandler();
		},

		data() {
			return {
				loaded: false,
				disableDialogActive: false, disableSelected: '',
				search: { text: "", status: "", type: "", subscription: "" },
				loadMore: false,
				filmList: []
			}
		},
		methods: {
			searchHandler(more = false) {
				let size = 50;
				this.$http.post(this.config.api + "/user/slideshow/search").then(data => {
					this.loaded = true;
					if (data.body.data.length == size) this.loadMore = true;
					else this.loadMore = false;
					this.filmList = more ? this.filmList.concat(data.body.data) : data.body.data;
				})
			},
			onDelete(hash) {

				if (this.disableSelected == "") {
					this.disableDialogActive = true;
					this.disableSelected = hash;
					return;
				}
				this.$http.post(this.config.api + "/user/slideshow/delete", {
					hash: this.disableSelected
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "លុយដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
					}
					this.searchHandler();
					this.onCancel();
				})
			},

			onUpdate(hash) {

				this.$http.post(this.config.api + "/user/slideshow/update", {
					hash: hash
				}).then(res => {
					this.searchHandler();
					this.onCancel();
				})
			},
			onCancel() {
				this.disableSelected = ""
				this.disableDialogActive = false
			}
		}
	}
</script>
<style scoped>
	.poster {
		height: 70px;
		margin-right: 20px;
		width: auto;
	}
	.cover {
		width: 120px;
		margin-left: 10px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>


// WEBPACK FOOTER //
// src/pages/Slideshows/View.vue